import { AxiosError } from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ErrorResponse } from 'store/ReduxTypes';
import { TrainingPlanResponse, ExerciseVideoResponse } from './TrainingsTypes';
import { api } from '@utils/api';

/* 1. POST /api/v1/training-requests?instance_id=… */
export const requestTrainingPlanOperation = createAsyncThunk<
  TrainingPlanResponse,
  number,
  { rejectValue: ErrorResponse }
>('trainings/requestPlan', async (instanceId, { rejectWithValue }) => {
  try {
    const { data } = await api.post<TrainingPlanResponse>(
      '/training-requests',
      {},
      { params: { instance_id: instanceId } },
    );
    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});

/* 2. GET /api/v1/training-requests/latest */
export const getLatestTrainingPlanOperation = createAsyncThunk<
  TrainingPlanResponse,
  void,
  { rejectValue: ErrorResponse }
>('trainings/latestPlan', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get<TrainingPlanResponse>('/training-requests/latest');
    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message, status: e.response?.status });
  }
});

/* 3. GET /api/v1/training-requests/{request_id} */
export const getTrainingPlanStatusOperation = createAsyncThunk<
  TrainingPlanResponse,
  number,
  { rejectValue: ErrorResponse }
>('trainings/planStatus', async (requestId, { rejectWithValue }) => {
  try {
    const { data } = await api.get<TrainingPlanResponse>(`/training-requests/${requestId}`);
    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});

/* 4. POST /api/v1/resources/exercise-videos (body { name }) */
export const fetchExerciseVideoOperation = createAsyncThunk<
  ExerciseVideoResponse,
  string,
  { rejectValue: ErrorResponse }
>('trainings/fetchVideo', async (exerciseName, { rejectWithValue }) => {
  try {
    const { data } = await api.post<ExerciseVideoResponse>('/resources/exercise-videos', {
      name: exerciseName,
    });
    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});
